import * as React from 'react'
import {Dialog, DialogBody, DialogHeading} from '@frontrow/console/src/components/ui/dialog'
import {Button} from '@frontrow/console/src/components/button'

import {deleteDistrict} from '@frontrow/console/src/helpers/api-districts'
import {type DistrictT} from '@frontrow/console/src/models/district'
import {buttonContainer, cancel} from './district-delete-button-modal.module.scss'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type ComponentProps = {
  districtToDelete: DistrictT
}

export function DistrictDeleteButtonModal(props: ComponentProps): React.ReactElement {
  const {districtToDelete} = props
  const {isOpen, open, close, isLoading: loading, error, handleAsyncAction} = useModalForm()

  const onConfirmDelete = async () => {
    await handleAsyncAction(async () => {
      await deleteDistrict(districtToDelete.id)
      close()
    })
  }

  const errorNode =
    error !== null ? (
      <div>
        <p>Could not delete district: {error}</p>
      </div>
    ) : null

  return (
    <React.Fragment>
      <Button title="Delete District" style="link" onClick={open}>
        <i className="fa fa-trash fa-lg" />
      </Button>
      <Dialog open={isOpen} onClose={close}>
        <DialogHeading>Delete district {districtToDelete.name}?</DialogHeading>
        <DialogBody>
          <div>
            <p>WARNING: THIS OPERATION IS IRREVERSIBLE.</p>
          </div>

          {errorNode}

          <div className={buttonContainer}>
            <Button style="secondary" addClass={cancel} onClick={close}>
              Cancel
            </Button>
            <Button disabled={loading} onClick={onConfirmDelete}>
              Delete District
            </Button>
          </div>
        </DialogBody>
      </Dialog>
    </React.Fragment>
  )
}
